// extracted by mini-css-extract-plugin
module.exports = {"popover":"Vf4tctv_","userAvatar":"SSSr66xc","username":"__89r3tV8H","official":"b5u_2gLu","info":"__9KyAOVzn","followButtonContainer":"DpdzAi3f"};